const initialState = {
  loading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_REDUCERS':
      return initialState;
    case 'AUTHENTICATION':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'AUTHENTICATION_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null
      };
    case 'AUTHENTICATION_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};
